




















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import User from "../../models/user/User";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import {countryName, enumTextFromValue} from "@/helpers/functions_asi";
import {EmploymentType, Gender, Permissions} from "@/helpers/constants";
import CardBlamable from "@/components/CardBlamable.vue";
import UserUpdateDialogBasicData from "@/components/user/UserUpdateDialogBasicData.vue";

@Component({
	components: {UserUpdateDialogBasicData, CardBlamable, AsiCardDetailEntry, AsiCardDetail}
})
export default class UserCardBasicData extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get gender(): string | null {
		return enumTextFromValue(Gender, this.user?.gender ?? null, true);
	}

	private get employmentType(): string | null {
		return enumTextFromValue(EmploymentType, this.user?.employmentType ?? null, true);
	}

	private get fullName(): string | null {
		return User.fullName(this.user);
	}

	private get countryName(): string | null {
		return countryName(this.user?.countryCode ?? null);
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('userChanged')
	public userChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
